import { TypeOf } from 'io-ts';

import { codecFromArray } from '@dmb/core';

export const [DmbFontSizeC, DmbFontSizes] = codecFromArray(['smallest', 'smaller', 'small', 'regular']);
export type DmbFontSize = TypeOf<typeof DmbFontSizeC>;

export const isFontSize = (v: unknown): v is DmbFontSize =>
  !!v && typeof v === 'string' && (DmbFontSizes as string[]).includes(v);
